export default "__VITE_ASSET__Ch84ZKQX__"